import CYBERTEC_LOGO from './logo/CYBERTEC.svg';
import EDB_LOGO from './logo/EDB.svg';
import MICROSOFT_LOGO from './logo/Microsoft.svg';
import PERCONA_LOGO from './logo/Percona.png';
import FUJITSU_LOGO from './logo/fujitsu.svg';
import XATA_LOGO from './logo/xata.png';
import AWS_LOGO from './logo/aws.svg';
import HIGHGO_LOGO from './logo/highgo.svg';
import PGANALYZE_LOGO from './logo/pganalyze.svg';
import HUAWEI_LOGO from './logo/huawei.png';
import SUPABASE_LOGO from './logo/supabase.svg';
import DATABRICKS_LOGO from './logo/databricks.svg';
import SRA_LOGO from './logo/SRA.png';
import SNOWFLAKE_LOGO from './logo/snowflake.svg';

export const SPONSOR_LIST = {
  GOLD: [
    {
      NAME: 'EDB',
      URL: 'https://www.enterprisedb.com/',
      LOGO: EDB_LOGO,
      DESCRIPTION:
        'As the leading contributor to PostgreSQL, EDB is committed to building the next generation of Postgres for operators, developers, data engineers, and AI builders. EDB provides a modern Postgres data platform for transactional, analytical, and new AI workloads powered by an enhanced Postgres engine.',
    },
    {
      NAME: 'Microsoft',
      URL: 'https://aka.ms/pg-at-microsoft',
      LOGO: MICROSOFT_LOGO,
      DESCRIPTION:
        'At Microsoft, our Postgres team is focused on advancing Postgres—by contributing to Postgres open source; by providing the Azure Database for PostgreSQL and Azure HorizonDB services; by contributing to the Postgres ecosystem with Citus, Patroni, and VS Code; and by supporting the Postgres community.',
    },
    {
      NAME: 'AWS',
      URL: 'https://aws.amazon.com',
      LOGO: AWS_LOGO,
      DESCRIPTION:
        "Amazon Web Services (AWS) is the world's most comprehensive & broadly adopted cloud provider, with 200+ fully featured services spanning over 35 geographic regions. With many solutions built for & around PostgreSQL, we strive to be a leading employer & contributor within the PostgreSQL community.",
    },
    {
      NAME: 'Huawei',
      URL: 'https://www.huawei.com/en',
      LOGO: HUAWEI_LOGO,
      DESCRIPTION:
        "Huawei Cloud has become one of the world's fastest-growing major cloud vendors. Huawei Cloud is committed to providing Everything as a Service to deliver reliable, secure, trustworthy, and sustainable cloud services for customers, partners, and developers. As a core service of databases, our team is focused on providing a fully managed PostgreSQL service with better experience, performance, scalability and availability.",
    },
    {
      Name: 'Databricks',
      URL: 'https://databricks.com/',
      LOGO: DATABRICKS_LOGO,
      DESCRIPTION:
        "With origins in academia and the open source community, Databricks was founded in 2013 by the original creators of the lakehouse architecture and open source projects Apache Spark™, Delta Lake, MLflow and Unity Catalog.\\nToday, more than 15,000 organizations worldwide — including Block, Comcast, Condé Nast, Rivian, Shell and over 60% of the Fortune 500 — rely on the Databricks Data Intelligence Platform to take control of their data and put it to work with AI.\\nHeadquartered in San Francisco, with offices around the world, Databricks is on a mission to simplify and democratize data and AI, helping data and AI teams solve the world's toughest problems.",
    },
  ],
  SILVER: [
    {
      NAME: 'Percona',
      URL: 'https://www.percona.com',
      LOGO: PERCONA_LOGO,
    },
    {
      NAME: 'Fujitsu',
      URL: 'https://www.postgresql.fastware.com/',
      LOGO: FUJITSU_LOGO,
    },
    {
      NAME: 'HighGo',
      URL: 'https://www.highgo.com/en/',
      LOGO: HIGHGO_LOGO,
    },
    {
      NAME: 'Duboce Labs, Inc.',
      URL: 'https://pganalyze.com',
      LOGO: PGANALYZE_LOGO,
    },
    {
      NAME: 'Supabase',
      URL: 'https://supabase.com/',
      LOGO: SUPABASE_LOGO,
    },
    {
      NAME: 'SRA OSS',
      URL: 'https://www.sraoss.co.jp/index_en/',
      LOGO: SRA_LOGO,
    },
    {
      NAME: 'Snowflake',
      URL: '	https://www.snowflake.com/en/',
      LOGO: SNOWFLAKE_LOGO,
    },
  ],
  BRONZE: [
    {
      NAME: 'CYBERTEC',
      URL: 'https://www.cybertec-postgresql.com',
      LOGO: CYBERTEC_LOGO,
    },
    {
      NAME: 'Xata',
      URL: 'https://xata.io',
      LOGO: XATA_LOGO,
    },
  ],
};
